import { Highlight } from '@modules/feedback/types';
import { Box } from '@mui/material';
import { ReactNode } from 'react';

interface FeedbackHighlightProps {
  bgcolor: string;
  color: string;
  highlight: Highlight;
  children: ReactNode;
  msgIndex?: number;
}

const FeedbackHighlight = ({
  bgcolor,
  color,
  highlight,
  children,
  msgIndex = 0,
}: FeedbackHighlightProps) => {
  return (
    <Box
      component="span"
      bgcolor={bgcolor}
      color={color}
      data-highlight-id={highlight.id + msgIndex.toString()}
    >
      {children}
    </Box>
  );
};

export default FeedbackHighlight;
